(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[530],{

/***/ 6511:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LazyProductImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2050);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9957);
/* harmony import */ var _utils_agent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9754);



// @ts-nocheck



function LazyProductImage(props) {
    var getImageExtension = function getImageExtension(src) {
        if (src && agent.hasWebp && !props.disableWebp) {
            return src.replace(/.jpg/g, ".webp").replace(/.png/g, ".webp");
        }
        return src;
    };
    var renderImage = function renderImage() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
            alt: props.alt,
            src: getImageExtension(props.src),
            width: props.width,
            height: props.height,
            srcSet: getImageExtension(props.srcSet),
            className: (props.className || "") + (!props.disableAnim ? " animated fadeIn" : null)
        });
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({}), 2), agent = ref[0], setUserAgent = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var ua = (0,_utils_agent__WEBPACK_IMPORTED_MODULE_2__/* .getUserAgent */ .i)();
        setUserAgent(ua);
    }, []);
    // const supportsNativeLoading = useNativeLazyLoading()
    // console.log(supportsNativeLoading)
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* .InView */ .df, {
        triggerOnce: true,
        children: function(param) {
            var inView = param.inView, ref = param.ref;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: props.containerClassName,
                style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    height: props.height !== "auto" ? +props.height : props.height,
                    width: props.width ? props.width : "auto"
                }, props.style),
                ref: ref,
                children: [
                    inView ? renderImage() : null,
                    props.children
                ]
            });
        }
    });
};


/***/ }),

/***/ 5374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3496);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7378);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6511);
/* harmony import */ var _Footer_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9760);
/* harmony import */ var _Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);






function FooterNewComponent(props) {
    var ref = (0,next_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common"), t = ref.t, i18n = ref.i18n;
    var language = i18n.language;
    var getHomeUrl = function() {
        var store = props.store === "fr" ? "eu" : "us";
        return "/".concat(language !== null && language !== void 0 ? language : "fr", "/").concat(store);
    };
    var _store, _store1, _store2, _store3, _store4, _store5, _store6, _store7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().footer), " ").concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[props.variant] || ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "container align-items-center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "row ".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-4 col-md-5 col-sm-12 ".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().content)),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: getHomeUrl(),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        height: "23",
                                        width: "82",
                                        alt: "Logo-new",
                                        src: "https://public.choose.app/website/new/images/Logo-new.png",
                                        srcSet: "https://public.choose.app/website/new/images/Logo-new@2x.png 2x,https://public.choose.app/website/new/images/Logo-new@3x.png 3x"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    dangerouslySetInnerHTML: {
                                        __html: t("slogan")
                                    }
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: props.store === "us" ? "https://www.instagram.com/choose_app_us/" : "https://instagram.com/choose_app",
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().instagram_icon)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-md-6 col-8 col-sm-12 ".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().pages)),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-md-6 col-sm-12 col-4",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: t("footer_about")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: {
                                                            pathname: "/about-us",
                                                            query: {
                                                                store: (_store = props.store) !== null && _store !== void 0 ? _store : "fr",
                                                                language: language
                                                            }
                                                        },
                                                        children: t("footer_history")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        href: "https://www.welcometothejungle.com/fr/companies/choose",
                                                        children: t("footer_join")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-md-6 col-sm-12 col-4 ".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().help)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: t("footer_help")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "mailto:contact@appchoose.io",
                                                        children: t("footer_contact")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: {
                                                            pathname: "/shipping",
                                                            query: {
                                                                store: (_store1 = props.store) !== null && _store1 !== void 0 ? _store1 : "fr",
                                                                language: language
                                                            }
                                                        },
                                                        children: t("footer_delivery")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: {
                                                            pathname: "/returns",
                                                            query: {
                                                                store: (_store2 = props.store) !== null && _store2 !== void 0 ? _store2 : "fr",
                                                                language: language
                                                            }
                                                        },
                                                        children: t("footer_return")
                                                    })
                                                }),
                                                t("footer_payment") !== "footer_payment" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                        href: {
                                                            pathname: "/payment",
                                                            query: {
                                                                store: (_store3 = props.store) !== null && _store3 !== void 0 ? _store3 : "fr",
                                                                language: language
                                                            }
                                                        },
                                                        children: t("footer_payment")
                                                    })
                                                }) : null
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "col-md-6 col-sm-12 col-4 ".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().pro)),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: t("footer_pro")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: t("footer_typeform"),
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: t("footer_contact_us_pro")
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("footer", {
                    className: "row ".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-sm-8 col-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    height: "16",
                                    width: "19",
                                    alt: "LOVE",
                                    src: "https://public.choose.app/website/new/images/SmallHeart.png",
                                    srcSet: "https://public.choose.app/website/new/images/SmallHeart@2x.png 2x,https://public.choose.app/website/new/images/SmallHeart@3x.png 3x"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    style: {
                                        marginLeft: 8
                                    },
                                    children: t("footer_paris")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().copyright), " col-sm-4 col-2"),
                            children: "\xa9 2018-2024, Choose"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-sm-6 col-5 ".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().links)),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().copyright),
                                    href: {
                                        pathname: "/cgv",
                                        query: {
                                            store: (_store4 = props.store) !== null && _store4 !== void 0 ? _store4 : "fr",
                                            language: language
                                        }
                                    },
                                    children: t("footer_cgv")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().copyright),
                                    href: {
                                        pathname: "/privacy",
                                        query: {
                                            store: (_store5 = props.store) !== null && _store5 !== void 0 ? _store5 : "fr",
                                            language: language
                                        }
                                    },
                                    children: t("footer_privacy")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().copyright),
                                    href: {
                                        pathname: "/mentions_legales",
                                        query: {
                                            store: (_store6 = props.store) !== null && _store6 !== void 0 ? _store6 : "fr",
                                            language: language
                                        }
                                    },
                                    children: t("footer_mentions")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().copyright),
                                    href: {
                                        pathname: "/cgu",
                                        query: {
                                            store: (_store7 = props.store) !== null && _store7 !== void 0 ? _store7 : "fr",
                                            language: language
                                        }
                                    },
                                    children: t("footer_cgu")
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FooterNewComponent);


/***/ }),

/***/ 5365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ HeaderNewComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2050);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4246);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7378);
/* harmony import */ var _Header_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5262);
/* harmony import */ var _Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Header_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6511);
/* harmony import */ var _utils_lang__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3703);
/* harmony import */ var _utils_agent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9754);
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1936);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9894);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);









// tslint:disable-next-line:cognitive-complexity
function HeaderNewComponent(props) {
    var onClickApple = function onClickApple() {
        (0,_api__WEBPACK_IMPORTED_MODULE_5__/* .trackEventSegment */ .P)("clickApple", {
            store: props.store,
            lang: props.language
        });
    };
    var onclickAndroid = function onclickAndroid() {
        (0,_api__WEBPACK_IMPORTED_MODULE_5__/* .trackEventSegment */ .P)("clickAndroid", {
            store: props.store,
            lang: props.language
        });
    };
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(false), 2), hasScrolled = ref[0], setScrolled = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({}), 2), userAgent = ref1[0], setUserAgent = ref1[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        var ua = (0,_utils_agent__WEBPACK_IMPORTED_MODULE_3__/* .getUserAgent */ .i)();
        setUserAgent(ua);
        if (!props.disableScroll) {
            var isBrowser = "object" !== "undefined";
            if (isBrowser) {
                var handleScroll = function() {
                    setScrolled(window.scrollY > 56);
                };
                window.addEventListener("scroll", handleScroll);
                setScrolled(window.scrollY > 56);
                return function() {
                    return window.removeEventListener("scroll", handleScroll);
                };
            }
        }
    }, [
        props.disableScroll
    ]);
    var className = "".concat((_Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default().header), " ").concat((_Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default())[props.variant || ""] || "", " ").concat(hasScrolled ? (_Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default().scroll) : "", " ").concat(props.disableScroll ? (_Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["no-scroll"]) : "").trim();
    var className2 = "".concat((_Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default().column), " col-6 col-sm-12 ").concat(props.showSlogan ? (_Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default().hasSlogan) : "").trim();
    var getHomeUrl = function() {
        var store = props.store === "fr" ? "eu" : "us";
        var _language;
        return "/".concat((_language = props.language) !== null && _language !== void 0 ? _language : "fr", "/").concat(store);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
        className: className,
        style: {
            boxShadow: !hasScrolled || props.disableScroll ? "none" : undefined
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container align-items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "".concat((_Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default().container), " row"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: className2,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                                href: {
                                    pathname: getHomeUrl()
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    alt: "Logo-new",
                                    src: "https://public.choose.app/website/new/images/Logo-new.png",
                                    srcSet: "https://public.choose.app/website/new/images/Logo-new@2x.png 2x,https://public.choose.app/website/new/images/Logo-new@3x.png 3x",
                                    style: {
                                        cursor: "pointer"
                                    }
                                })
                            }),
                            props.showSlogan ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: (_Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default().slogan),
                                children: [
                                    "Your daily drop of ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        children: "cool"
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    hasScrolled || props.disableScroll && !props.hideBtns ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "animated fadeIn ".concat((_Header_module_scss__WEBPACK_IMPORTED_MODULE_7___default().stores), " col-6"),
                        children: [
                            userAgent.isMobile && !userAgent.isAndroid || !userAgent.isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                style: {
                                    marginRight: 16
                                },
                                onClick: onClickApple,
                                title: "Apple Store",
                                className: "plausible-event-name=Download+App plausible-event-platform=apple plausible-event-from=header",
                                href: "https://apps.apple.com/fr/app/choose-concept-store/id985799982?mt=8&ct=website",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    width: "134",
                                    alt: "Apple Store",
                                    height: "40",
                                    src: "https://public.choose.app/website/new/images/btn-small-app-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(), ".svg")
                                })
                            }) : null,
                            userAgent.isMobile && userAgent.isAndroid || !userAgent.isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                onClick: onclickAndroid,
                                href: "https://play.google.com/store/apps/details?id=com.appchoose.choose.android&hl=fr&gl=FR",
                                rel: "noopener noreferrer",
                                className: "plausible-event-name=Download+App plausible-event-platform=android plausible-event-from=header",
                                target: "_blank",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_lazy_product_image_lazy_product_image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    height: "41",
                                    width: "136",
                                    alt: "Play Store",
                                    src: "https://public.choose.app/website/new/images/btn-small-play-store-".concat((0,_utils_lang__WEBPACK_IMPORTED_MODULE_8__/* .getLang */ .V)(), ".svg")
                                })
                            }) : null
                        ]
                    }) : null
                ]
            })
        })
    });
}


/***/ }),

/***/ 3703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ getLang; }
/* harmony export */ });
var getLang = function(i18n) {
    // const { i18n } = useTranslation('common');
    return (i18n === null || i18n === void 0 ? void 0 : i18n.language) === "fr" ? "fr" : "en";
// return "en"
};


/***/ }),

/***/ 9760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__XV1hM","container":"Footer_container__kQ6r_","instagram_icon":"Footer_instagram_icon__HxzHC","white":"Footer_white__iuE20","pages":"Footer_pages__6VkLI","copyright":"Footer_copyright__v3_pZ","links":"Footer_links__cPFFj","content":"Footer_content__zHMEl","pro":"Footer_pro__sEIJj","help":"Footer_help__LGAZh"};

/***/ }),

/***/ 5262:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header___PCKW","scroll":"Header_scroll__oSisG","stores":"Header_stores__BEQDH","hasSlogan":"Header_hasSlogan__Zsy43","no-scroll":"Header_no-scroll__glSSe","column":"Header_column__rXUU2","slogan":"Header_slogan__OXBSz","beige":"Header_beige__WVy90","container":"Header_container__MPCPH","beige-center":"Header_beige-center__OnAXV"};

/***/ })

}]);